import config from "lib/fr-config";

let nowDate;

const getImmutablePriceInfo = () => {
  nowDate = nowDate || new Date();

  const priceHistoryArr = config.membership.priceHistory;

  for (const priceObj of priceHistoryArr) {
    const expiredDate = new Date(priceObj.validUntil);

    if (nowDate < expiredDate) {
      return priceObj;
    }
  }

  return {};
};

const deletePriceInfo = () => {
  nowDate = null;
};

export { deletePriceInfo, getImmutablePriceInfo };
